import { SPACE, THEME } from '@HoudiniUI/Theme/theme';
import { StyleSheet } from 'aphrodite';
import { cardStyle } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	// Chrome and type both come from the sidebar: no family is named anywhere here, so the card
	// inherits the app's body font rather than standing out in Lexend beside its neighbours.
	card: {
		...cardStyle,
		boxSizing: 'border-box',
		display: 'flex',
		fontSize: THEME.typography.fontSizes.sm,
		flexDirection: 'column',
		gap: SPACE[8],
		padding: SPACE[16],
	},
	embedded: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
	},
	header: {
		alignItems: 'baseline',
		display: 'flex',
		gap: SPACE[8],
		justifyContent: 'space-between',
	},
	title: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.md,
	},
	roundCount: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
		whiteSpace: 'nowrap',
	},
	rule: {
		backgroundColor: THEME.colors.border.light,
		height: 1,
	},
	// Layout only — Button's `link` variant carries the colour, type and interactive states.
	trigger: {
		gap: SPACE[4],
		justifyContent: 'flex-start',
		padding: 0,
		width: 'fit-content',
	},
	chevron: {
		flexShrink: 0,
		height: 16,
		transition: 'transform 150ms ease-out',
		width: 16,
	},
	chevronOpen: {
		transform: 'rotate(180deg)',
	},
	list: {
		display: 'flex',
		flexDirection: 'column',
		listStyle: 'none',
		margin: 0,
		paddingLeft: 0,
	},
	entry: {
		display: 'flex',
		gap: SPACE[12],
	},
	rail: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		width: 8,
	},
	dot: {
		backgroundColor: THEME.colors.border.main,
		borderRadius: '50%',
		flexShrink: 0,
		height: 8,
		// Centres the dot on the round label's cap height rather than its line box.
		marginTop: SPACE[4],
		width: 8,
	},
	dotCurrent: {
		backgroundColor: THEME.colors.primary.main,
		boxShadow: `0 0 0 2px ${THEME.colors.primary.light}`,
	},
	connector: {
		backgroundColor: THEME.colors.border.light,
		flexGrow: 1,
		marginTop: SPACE[4],
		width: 1,
	},
	entryBody: {
		display: 'flex',
		flexDirection: 'column',
		flexGrow: 1,
		gap: SPACE[4],
		paddingBottom: SPACE[16],
	},
	entryBodyLast: {
		paddingBottom: 0,
	},
	entryHeader: {
		alignItems: 'center',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[8],
	},
	roundLabel: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	metaRow: {
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: THEME.typography.fontSizes.sm,
		gap: SPACE[4],
	},
	metaLabel: {
		color: THEME.colors.text.light,
	},
	metaValue: {
		color: THEME.colors.text.main,
	},
	note: {
		backgroundColor: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
		marginTop: SPACE[4],
		padding: SPACE[12],
	},
	noteText: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.5,
	},
	noteByline: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	annotations: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	annotationLink: {
		alignSelf: 'flex-start',
	},
	message: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
});
